<div class="flex td-text-to-date justify-between" [class.!text-gray-600]="disabled">
  <input [formControl]="fc" autocomplete="off" (focus)="onFocusIn()" (blur)="onFocusOut($event)" class="flex-1" />
  <div>{{ displayValue$ | async }}</div>
</div>
